import React from "react";

const Button = ({ children, type, ...rest }) => {
  return (
    <button 
    className="bg-blue-600 sm:w-auto sm:h-auto p-4 inline-block h-auto py-2 px-8 border-none rounded-md font-medium text-lg text-center cursor-pointer overflow-hidden text-white"
    type={type === 'submit' ? 'submit' : 'button'}
    {...rest}
    >
      {children}
    </button>
  );
};

function SelectButton ({children, id, ...rest}) {
    return (
        <select id={id} className="bg-gray-400 sm:w-auto sm:h-auto p-4 inline-block h-auto py-2 px-8 border-none rounded-md font-medium text-lg text-center cursor-pointer overflow-hidden text-white"{...rest}>{children}</select>
    )
}

export {SelectButton}
export default Button;
